export const proposallistData = [
  {
    data: "2024-01-15",
    sendTo: "NovaWave LLC",
    client_img: "assets/img/icons/company-icon-01.svg",
    produto: "Brinquedos Sortidos",
    quantidade: 200,
    valor: 205426.00,
    dataVencimento: "2024-02-15",
    dataPagamento: null,
    total: 205426.00,
    totalAPagar: 205426.00,
    situacao: "Pendente",
    pagamento: "Boleto",
    id: "1",
    percentualConcluido: 30,
    transactionId: "ORC2024-0001"
  },
  {
    data: "2024-01-16",
    sendTo: "Redwood Inc",
    client_img: "assets/img/icons/company-icon-02.svg",
    produto: "Taco de Baisebol",
    quantidade: 50,
    valor: 21050.00,
    dataVencimento: "2024-02-16",
    dataPagamento: "2024-01-20",
    total: 21050.00,
    totalAPagar: 0,
    situacao: "Aprovado",
    pagamento: "Transferência",
    id: "2",
    percentualConcluido: 20,
    transactionId: "ORC2024-0002"
  },
  {
    data: "2024-01-17",
    sendTo: "HarborView",
    client_img: "assets/img/icons/company-icon-03.svg",
    produto: "Bola de Futebol",
    quantidade: 40,
    valor: 405656.00,
    dataVencimento: "2024-03-17",
    dataPagamento: null,
    total: 405656.00,
    totalAPagar: 405656.00,
    situacao: "Em análise",
    pagamento: "Boleto",
    id: "3",
    percentualConcluido: 15,
    transactionId: "ORC2024-0003"
  },
  {
    data: "2024-01-18",
    sendTo: "CoastalStar Co.",
    client_img: "assets/img/icons/company-icon-04.svg",
    produto: "Alicate",
    quantidade: 30,
    valor: 205426.00,
    dataVencimento: "2024-02-28",
    dataPagamento: null,
    total: 205426.00,
    totalAPagar: 205426.00,
    situacao: "Pendente",
    pagamento: "Crédito",
    id: "4",
    percentualConcluido: 30,
    transactionId: "ORC2024-0004"
  },
  {
    data: "2024-01-19",
    sendTo: "RiverStone Ventur",
    client_img: "assets/img/icons/company-icon-05.svg",
    produto: "Pacote Marketing Digital",
    quantidade: 20,
    valor: 315145.00,
    dataVencimento: "2024-02-19",
    dataPagamento: "2024-01-25",
    total: 315145.00,
    totalAPagar: 0,
    situacao: "Aprovado",
    pagamento: "Transferência",
    id: "5",
    percentualConcluido: 10,
    transactionId: "ORC2024-0005"
  }
];
